import { render, staticRenderFns } from "./ProblemEdit.vue?vue&type=template&id=77b6cb44"
import script from "./ProblemEdit.vue?vue&type=script&lang=js"
export * from "./ProblemEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports